export const onCellValueChangedEvent = ({ params, onCellValueChanged }) => {
  if (onCellValueChanged) onCellValueChanged(params);
};